import { render, staticRenderFns } from "./OrderTotals.vue?vue&type=template&id=ec4e4124&scoped=true&"
import script from "./OrderTotals.vue?vue&type=script&lang=js&"
export * from "./OrderTotals.vue?vue&type=script&lang=js&"
import style0 from "./OrderTotals.vue?vue&type=style&index=0&id=ec4e4124&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4e4124",
  null
  
)

/* custom blocks */
import block0 from "@/locales/order_totals.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fjenkins%2Fworkspace%2Fon-production-deploy%2Ffront%2Fcomponents%2F_shared%2FOrder%2FTotals%2FOrderTotals.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports